/**
 * Created by Jerker Nord on 2019-03-15.
 */
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite} from "gsap";
import {ThorGameConfig} from "../../ThorGameConfig";

export class ThorInitialWPView extends BaseView {

    private static SPINE_ASSET_NAME:string = "multiplyWinTotalSpine";

    private _layer:ScalableLayer;
    private _multiplyAnimation:PIXI.spine.Spine;

    constructor() {
        super();
        this._layer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name);
    }

    protected initAnimations():void {
        this._multiplyAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset(ThorInitialWPView.SPINE_ASSET_NAME));
        const multiplyContainer:PIXI.Sprite = new PIXI.Sprite();
        multiplyContainer.anchor.set(0.5, 0.5);
        multiplyContainer.addChild(this._multiplyAnimation);
        multiplyContainer.position.set(ThorGameConfig.instance.GAME_WIDTH / 2, (ThorGameConfig.instance.GAME_HEIGHT / 2) - 20);
        this._layer.addChild(multiplyContainer);
    }

    public getMultiplyAnimationTL(level:number):TimelineLite {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(() => this._multiplyAnimation.skeleton.setSkin(null));
        timeline.add(() => this._multiplyAnimation.skeleton.setSkinByName(level.toString()));
        timeline.add(() => this._multiplyAnimation.skeleton.setSlotsToSetupPose());
        timeline.add(new SpineTween(this._multiplyAnimation, 0, "WinTot", 0));
        return timeline;
    }
}